
'use strict';

define('component!AcademyCourseComponent',['require','prop-types','react','create-react-class','classnames'],function (require) {
  'use strict';

  var PropTypes = require('prop-types');

  var React = require('react');
  var ReactCreateClass = require('create-react-class');
  var classNames = require('classnames');

  var AcademyCourseComponent = ReactCreateClass({
    propTypes: {
      course: PropTypes.object.isRequired,
      translations: PropTypes.object.isRequired
    },

    render: function render() {
      var next;
      var props = this.props;
      var assignments = props.course.assignments.map(function (assignment) {
        var clone = {
          id: assignment.id
        };

        var iconClass = classNames({
          'academy-course-component__assignment-checkmark': true,
          'is-completed': assignment.completed
        });

        if (!next && !assignment.completed) {
          next = assignment;
        }

        clone.classes = classNames({
          'academy-course-component__assignment': true,
          'is-completed': assignment.completed,
          'is-next': next === assignment
        });
        clone.iconClass = iconClass;

        clone.title = props.translations[assignment.id];

        return clone;
      });

      return React.createElement(
        'ul',
        { className: 'academy-course-component' },
        assignments.map(function (assignment) {
          return React.createElement(
            'li',
            { className: assignment.classes, key: assignment.id },
            assignment.title,
            React.createElement('i', { className: assignment.iconClass })
          );
        })
      );
    }
  });

  return AcademyCourseComponent;
});
